module.exports = __webpack_public_path__ + "static/img/weixin_service.add3b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/img/weixin_service.png
// module id = Nd23
// module chunks = 32